export enum WithdrawTypeGamblingEnum {
  "ACCEPT-FIRST_DEPOSIT" = "ACCEPT-FIRST_DEPOSIT",
  "ACCEPT-QUALIFICATION" = "ACCEPT-QUALIFICATION",
  REQUEST = "REQUEST"
}